
const GET_EVENT_REG_LINKS = 'GET_EVENT_REG_LINKS';
const GET_EVENT_COMPETITIONS = 'GET_EVENT_COMPETITIONS';
const GET_USER_DATA = 'GET_USER_DATA';
const GET_EVENT_REG_BY_ID = 'GET_EVENT_REG_BY_ID';
const ADD_ATTENDENCE = 'ADD_ATTENDENCE';
const CONFIRM_MAIL = 'CONFIRM_MAIL';
const REMOVE_ATTENDENCE = 'REMOVE_ATTENDENCE';

const SET_LINK = 'SET_LINK';
const SET_EVENT_COMPETITION = 'SET_EVENT_COMPETITION';
const SET_SELECTED_EVENT = 'SET_SELECTED_EVENT';
const CLEAR = 'CLEAR';

export default {
	GET_EVENT_REG_LINKS,
	GET_EVENT_COMPETITIONS,
	GET_USER_DATA,
	GET_EVENT_REG_BY_ID,
	SET_LINK,
	SET_EVENT_COMPETITION,
	SET_SELECTED_EVENT,
	ADD_ATTENDENCE,
	CONFIRM_MAIL,
	REMOVE_ATTENDENCE,
	CLEAR,
};
